import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Send } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { InviteContact } from "@/components/contacts/InviteContact";

// After an import: the saved people who aren't on the app yet, each one tap away from an invite
export const InviteRest = ({ people, onDone, savedCount }) => {
  const qc = useQueryClient();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    qc.fetchQuery({ queryKey: ["state"], queryFn: api.state }).then((s) => {
      setRows(people.map((p) => {
        const w = s.wishlist.find((x) => x.id === p.wish_id);
        const i = (w?.contacts || []).findIndex((c) => c.name === p.name);
        return i < 0 ? null : { c: w.contacts[i], wishId: w.id, index: i };
      }).filter((r) => r && !r.c.joined_user_id));
    }, () => setRows([]));
  }, [people]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!rows) return null;
  return (
    <section className="rounded-xl border border-emerald-400/25 bg-emerald-400/[0.05] p-4 space-y-3" data-testid="invite-rest">
      <div className="flex items-start gap-2">
        <Send size={16} className="text-emerald-300 mt-0.5" />
        <div>
          <p className="text-sm font-medium">{savedCount ? `Saved ${savedCount}! ` : ""}Invite the rest</p>
          <p className="text-xs text-slate-400">{rows.length ? `${rows.length} ${rows.length === 1 ? "person isn't" : "people aren't"} on the bucketlist yet. One tap opens your message app with the invite written.` : "Everyone you saved is set."}</p>
        </div>
      </div>
      <ul className="divide-y divide-white/5" data-testid="invite-rest-list">
        {rows.map((r, n) => (
          <li key={`${r.wishId}-${r.index}`} className="flex items-center gap-3 py-2" data-testid={`invite-rest-row-${n}`}>
            <span className="flex-1 min-w-0 truncate text-sm">{r.c.name}</span>
            <InviteContact c={r.c} wishId={r.wishId} index={r.index} inline testId={`invite-rest-${n}`} />
          </li>
        ))}
      </ul>
      <Button onClick={onDone} variant="outline" className="w-full border-white/15 bg-transparent" data-testid="invite-rest-done">Done</Button>
    </section>
  );
};
